module.exports = __webpack_public_path__ + "static/img/index_1.33e83c88.jpg";